export default theme => ({
    bannerCalloutCta: {
        position: 'relative',
        marginBottom: 36,
        '& .desktop-image': {
            display: 'none !important',
            [theme.breakpoints.up('md')]: {
                display: 'block !important',
            },
        },
        '& .mobile-image': {
            display: 'block !important',
        },
        [theme.breakpoints.up('md')]: {
            '& .mobile-image': {
                display: 'none !important',
            }
        },
        '& > .gatsby-image-wrapper': {
            height: '595px !important',
            marginLeft: '50%',
            transform: 'translateX(-50%)',
            maxWidth: '100vw !important',
            width: 'calc(100% + 50px) !important',
            zIndex: '1',
            [theme.breakpoints.up('md')]: {
                height: '640px !important',
                width: '100vw !important',
            },
            '&::after': {
                position: 'absolute',
                display: 'block',
                content: '""',
                bottom: '0',
                left: '0',
                right: '0',
                height: 300,
                zIndex: '2',
                background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 45%,rgba(0,0,0,1) 100%)',
                opacity: '0.3',
                [theme.breakpoints.up('md')]: {
                    height: 340,
                    opacity: '0.51',
                    background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.58) 33%,rgba(0,0,0,1) 66%,rgba(0,0,0,1) 100%)',
                },
            },
        },
        '& .content-wrap': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            alignContent: 'center',
            justifyItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: 0,
            bottom: 0,
            zIndex: 1,
            width: '100%',
            '& h1, & h2, & h3, & h4, & h5, & h6': {
                color: 'white',
            }
        },
        '&.left-top .gatsby-image-wrapper img': {
            objectPosition: 'left top !important',
        },
        '&.left-center .gatsby-image-wrapper img': {
            objectPosition: 'left center !important',
        },
        '&.left-bottom .gatsby-image-wrapper img': {
            objectPosition: 'left bottom !important',
        },
        '&.center-top .gatsby-image-wrapper img': {
            objectPosition: 'center top !important',
        },
        '&.center-bottom .gatsby-image-wrapper img': {
            objectPosition: 'center bottom !important',
        },
        '&.right-top .gatsby-image-wrapper img': {
            objectPosition: 'right top !important',
        },
        '&.right-center .gatsby-image-wrapper img': {
            objectPosition: 'right center !important',
        },
        '&.right-bottom .gatsby-image-wrapper img': {
            objectPosition: 'right bottom !important',
        },
    },
    bannerCalloutCtaTheme: {
        ...theme.bannerCalloutCtaTheme,
    }
});